import React, { useState } from 'react';
import { T } from '../../../i18n/social';
const TOTAL = 8;

export default function Qualification({ lang = 'de', channel, onComplete }) {
  const t = T[lang].qual;
  const [step, setStep] = useState(1); // 1=privacy, 2=license, 3=german
  const [privacy, setPrivacy]   = useState(false);
  const [license, setLicense]   = useState(null);
  const [german, setGerman]     = useState(null);
  const [privacyError, setPrivacyError] = useState(false);

  const cardStyle = { maxWidth: '520px', margin: '0 auto' };

  const ChoiceBtn = ({ selected, onClick, icon, label }) => (
    <button type="button" onClick={onClick} style={{
      width: '100%', padding: '18px 20px', borderRadius: '14px', cursor: 'pointer',
      border: selected ? '2px solid #3E4954' : '2px solid #dde1e7',
      background: selected ? '#3E4954' : '#f8f9fa',
      color: selected ? '#fff' : '#1e2b38',
      fontWeight: 600, fontSize: '15px', fontFamily: 'var(--font-ui)',
      transition: 'all 150ms ease', textAlign: 'center', marginBottom: '10px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
      WebkitTapHighlightColor: 'transparent',
    }}>
      <span style={{ fontSize: '20px' }}>{icon}</span>
      {label}
    </button>
  );

  const NextBtn = ({ onClick, label = t.next, disabled }) => (
    <button onClick={onClick} disabled={disabled} style={{
      width: '100%', padding: '16px', background: disabled ? '#94a3b8' : '#3E4954',
      color: '#D0E5F5', border: 'none', borderRadius: '14px', fontSize: '16px',
      fontWeight: 700, cursor: disabled ? 'not-allowed' : 'pointer',
      fontFamily: 'var(--font-ui)', marginTop: '8px',
      WebkitTapHighlightColor: 'transparent',
    }}>
      {label} →
    </button>
  );

  // ── Step 1: Datenschutz ────────────────────────────────────────────────────
  const qualStepLabel = lang === 'uk' ? `Крок ${step} з ${TOTAL}` : lang === 'ru' ? `Шаг ${step} из ${TOTAL}` : `Schritt ${step} von ${TOTAL}`;
  if (step === 1) return (
    <div className="booking-card step-enter" style={cardStyle}>
      <div className="step-badge">{qualStepLabel}</div>
      <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '26px', fontWeight: 700,
        color: '#1e2b38', marginBottom: '6px', lineHeight: 1.2 }}>
        {t.privacy.label}
      </h2>
      <p style={{ fontSize: '14px', color: '#6b7a8d', marginBottom: '28px', fontFamily: 'var(--font-ui)' }}>
        {t.subtitle}
      </p>

      <div style={{ background: privacyError ? '#fff5f5' : '#f8f9fa', borderRadius: '14px',
        padding: '20px', marginBottom: '24px',
        border: privacyError ? '2px solid #f56565' : '2px solid transparent' }}>
        <label style={{ display: 'flex', gap: '14px', cursor: 'pointer', alignItems: 'flex-start' }}>
          <input type="checkbox" checked={privacy}
            onChange={e => { setPrivacy(e.target.checked); setPrivacyError(false); }}
            style={{ marginTop: '3px', width: '20px', height: '20px', flexShrink: 0, cursor: 'pointer', accentColor: '#3E4954' }} />
          <span style={{ fontSize: '14px', color: '#475569', lineHeight: 1.7, fontFamily: 'var(--font-ui)' }}>
            {t.privacy.text}{' '}
            <a href="https://zba.academy/datenschutz" target="_blank" rel="noopener noreferrer"
              style={{ color: '#3E4954', fontWeight: 700 }}>
              {t.privacy.link}
            </a>.
          </span>
        </label>
        {privacyError && (
          <p style={{ color: '#e53e3e', fontSize: '13px', marginTop: '10px', fontFamily: 'var(--font-ui)' }}>
            {t.privacy.required}
          </p>
        )}
      </div>

      <NextBtn onClick={() => { if (!privacy) { setPrivacyError(true); return; } setStep(2); }}
        label={t.next} />
    </div>
  );

  // ── Step 2: Führerschein ───────────────────────────────────────────────────
  if (step === 2) return (
    <div className="booking-card step-enter" style={cardStyle}>
      <div className="step-badge">{qualStepLabel}</div>
      <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '26px', fontWeight: 700,
        color: '#1e2b38', marginBottom: '6px', lineHeight: 1.2 }}>
        {t.license.label}
      </h2>
      <p style={{ fontSize: '15px', color: '#475569', marginBottom: '32px',
        fontFamily: 'var(--font-ui)', lineHeight: 1.6 }}>
        {t.license.question}
      </p>

      <ChoiceBtn selected={license === 'ja'} onClick={() => { setLicense('ja'); setTimeout(() => setStep(3), 250); }}
        icon="✅" label={t.license.yes} />
      <ChoiceBtn selected={license === 'nein'} onClick={() => { setLicense('nein'); setTimeout(() => setStep(3), 250); }}
        icon="❌" label={t.license.no} />
    </div>
  );

  // ── Step 3: Deutschkenntnisse ──────────────────────────────────────────────
  if (step === 3) return (
    <div className="booking-card step-enter" style={cardStyle}>
      <div className="step-badge">{qualStepLabel}</div>
      <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '26px', fontWeight: 700,
        color: '#1e2b38', marginBottom: '6px', lineHeight: 1.2 }}>
        {t.german.label}
      </h2>
      <p style={{ fontSize: '15px', color: '#475569', marginBottom: '32px',
        fontFamily: 'var(--font-ui)', lineHeight: 1.6 }}>
        {t.german.question}
      </p>

      <ChoiceBtn selected={german === 'ja'} onClick={() => { setGerman('ja'); setTimeout(() => onComplete({ privacy: true, deutschkenntnisse: 'ja', fuehrerschein_b: license }), 250); }}
        icon="✅" label={t.german.yes} />
      <ChoiceBtn selected={german === 'nein'} onClick={() => { setGerman('nein'); setTimeout(() => onComplete({ privacy: true, deutschkenntnisse: 'nein', fuehrerschein_b: license }), 250); }}
        icon="❌" label={t.german.no} />
    </div>
  );

  return null;
}
